import { Provider } from '@types';

export enum TimeOfDay {
  MORNING = 'Morning',
  AFTERNOON = 'Afternoon',
  EVENING = 'Evening',
}

export interface FiltersContextProps {
  hour: number | null;
  isActive: boolean;
  provider: Provider | null;
  resetFilters: () => void;
  setHour: (hour: number | null) => void;
  setProvider: (provider: Provider | null) => void;
  setShowFilters: (showFilters: boolean) => void;
  setTimeOfDay: (timeOfDay: TimeOfDay | null) => void;
  showFilters: boolean;
  timeOfDay: TimeOfDay | null;
}
